var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EipManage"},[_c('WujieVue',{attrs:{"width":"100%","height":"100%","name":"EipManage","url":_vm.url,"plugins":_vm.plugins,"props":_vm.propsData,"alive":true,"timeout":60000}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }